module.exports = __webpack_public_path__ + "img/blog-cv-4.9918e641.webp";